import { useState, useContext } from "react";

import { useMerch } from "@/services/hooks";

import { Box, Card, CardMedia, Typography } from "@mui/material";

import ActiveContentDrawer from "@/components/ActiveContentDrawer";
import { ShoppingCart } from "@mui/icons-material";
import { SubscribedContext } from "@/providers/Subscribed";

export default function MerchCard({ content }) {
  const [open, setOpen] = useState(false);
  const { isSubscribed, handleModalOpen } = useContext(SubscribedContext);

  const handleOpen = () => {
    if (isSubscribed) {
      setOpen(true);
    } else {
      handleModalOpen();
    }
  };

  return (
    <>
      <Box onClick={handleOpen}>
        <Card style={{ borderRadius: "20px", position: "relative" }}>
          <CardMedia
            component="img"
            src={content.meta.cover}
            style={{ borderRadius: "10px", aspectRatio: "1/1" }}
          />
          <Box
            style={{
              position: "absolute",
              bottom: 10,
              right: 10,
              margin: "8px",
              opacity: 0.8,
              color: "#04FFFF",
            }}
          >
            <ShoppingCart style={{ fontSize: "30px" }} />
          </Box>
        </Card>
      </Box>
      <ActiveContentDrawer content={content} open={open} setOpen={setOpen} />
    </>
  );
}
